module.exports = __webpack_public_path__ + "static/img/sort-back2.ceae7b38.png";